import React from 'react';
import { AccountCircle, NotificationsNone } from '@material-ui/icons';

export interface IMobileTopAppBarMenu {
  menu: string;
  url: string;
  urlParam?: string;
  subMenu?: Array<{
    label: string;
    url: string;
    urlParam: string;
  }>;
  icon: React.ReactNode;
}

export const routes: Array<IMobileTopAppBarMenu> = [
  {
    menu: '계정 설정',
    url: '/mypage/profile',
    icon: <AccountCircle fontSize="small" />
  },
  {
    menu: '알림 설정',
    url: '/mypage/notification',
    icon: <NotificationsNone fontSize="small" />
  }
];
